import { NavLink } from 'react-router-dom';
import { useLanguage } from './language-context';
import type { NavItem } from './nav-items';

// CB-17 admin section-chip row (DR-45; design D:423-429 `chipsShow`, script
// D:8461 `chipStyle`). Below 1200 px the rail collapses into one horizontally
// scrolling row of pill links under the header — it replaces the v1 bottom tab
// bar and the More screen (CB-18: `screens/more/` REMOVED). Same list and order
// as the rail, already filtered by the viewer's grants; labels only, no badges
// (design `navFlat` chips). Like the export, the row keeps its own scroll: it
// starts at the first chip and is not re-centred on the active one.

export function SectionChipRow({ items }: { items: NavItem[] }) {
  const { t } = useLanguage();

  return (
    <nav className="chip-row" aria-label={t('admin.nav.primary')}>
      {items.map((item) => {
        return (
          <NavLink
            key={item.section}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) => (isActive ? 'chip-row__chip is-active' : 'chip-row__chip')}
          >
            {t(item.key)}
          </NavLink>
        );
      })}
    </nav>
  );
}
